app.filter('humanTime', function () {
  return function (input) {
    return moment.utc(input).fromNow();
  };
});
